import { createSlice } from '@reduxjs/toolkit';
import {
    SLICE_NAME,
    postRequestModifications,
    postRequestApprove,
    getQuest,
    getQuestSolution
} from './service';
import { QuestSchema, QuestSolution } from 'src/types/quests';
import { mapServerAttachmentsToIAttachments } from '../../utils/attachments';

interface initialTypes {
    isLoading: boolean;
    error: string | null;
    quest: QuestSchema | null;
    questSolution: QuestSolution | null;
}

const initialState: initialTypes = {
    isLoading: false,
    error: null,
    quest: null,
    questSolution: null
};

export const QuestsSlice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {},

    extraReducers: {
        // Handlers for postRequestModifications
        [postRequestModifications.pending.type]: () => {},
        [postRequestModifications.fulfilled.type]: () => {},
        [postRequestModifications.rejected.type]: (state, action) => {
            state.error = action.payload;
        },
        // Handlers for postRequestApprove
        [postRequestApprove.pending.type]: () => {},
        [postRequestApprove.fulfilled.type]: () => {},
        [postRequestApprove.rejected.type]: (state, action) => {
            state.error = action.payload;
        },
        // Handlers for getQuest
        [getQuest.pending.type]: (state) => {
            if (!state.quest) {
                state.isLoading = true;
            }
        },
        [getQuest.fulfilled.type]: (state, action) => {
            state.isLoading = false;
            const questData = action.payload.data;

            // Map backend attachments to frontend format
            if (questData.attachments) {
                questData.attachments = mapServerAttachmentsToIAttachments(
                    questData.attachments
                );
            }

            state.quest = questData;
        },
        [getQuest.rejected.type]: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        // Handlers for getQuestSolution
        [getQuestSolution.pending.type]: (state) => {
            state.isLoading = true;
        },
        [getQuestSolution.fulfilled.type]: (state, action) => {
            state.isLoading = false;
            const solutionData = action.payload;

            // Map backend attachments to frontend format
            if (solutionData.attachments) {
                solutionData.attachments = mapServerAttachmentsToIAttachments(
                    solutionData.attachments
                );
            }

            state.questSolution = solutionData;
        },
        [getQuestSolution.rejected.type]: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const {} = QuestsSlice.actions;

export default QuestsSlice.reducer;
